import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";
import FilterImage from "../../Assets/filter.svg";
import FilterStyle from "./style";

// components
import HomeFilter from "./home";
import ProductFilter from "./product";
import ThemeFilter from "./themes";
import UserFilter from "./user";
import ZipFilter from "./zip";
import VideosFilter from "./videos";
import ServicesFilter from "./services";
import QuestionsFilter from "./questions";
import SettingsFilter from "./settings";
import BankFilter from "./banks";

function Filter(props) {
  const [Filter, showFilter] = useState(false);
  const [userItem, setUserItem] = useState("");
  const [status, setStatus] = useState("");

  useEffect(() => {
    props.userSelected(userItem);
    props.statusSelected(status);
  });

  useEffect(() => {
    setUserItem("");
    setStatus("");
  }, [props.clear]);

  const handleFilter = () => {
    switch (props.location.pathname) {
      case "/dashboard/home":
        return "home";
      case "/dashboard/product":
        return "product";
      case "/dashboard/themes":
        return "themes";
      case "/dashboard/users":
        return "users";
      case "/dashboard/banks":
        return "banks";
      case "/dashboard/zipcodes":
        return "zipcodes";
      case "/dashboard/videos":
        return "videos";
      case "/dashboard/services":
        return "services";
      case "/dashboard/questions":
        return "questions";
      case "/dashboard/service-request":
        return "Service Requests";
      case "/dashboard/settings":
        return "settings";
      case "/dashboard/admin":
        return "admin";
      case "/dashboard/mobile-configuration":
        return "mobile configuration";
    }
  };

  return (
    <div className="position-relative">
      <span className="filter-count position-absolute f-12">
        {userItem.length + status.length}
      </span>
      <img
        onClick={() => showFilter(true)}
        src={FilterImage}
        alt="Filter"
        className="ml-3 cursor-pointer"
      />
      {Filter && (
        <div>
          <div
            className="overlay"
            onClick={() => showFilter(false)}
            style={{ zIndex: "9" }}
          />
          <div
            className="dark-background rounded pt-3 pl-3 pr-3 mt-3 position-absolute"
            style={{ zIndex: "10", width: "220px" }}
          >
            <ul className="list-unstyled m-0">
              {handleFilter() === "home" && (
                <HomeFilter
                  state={props.state}
                  method={props.onClick}
                  close={() => showFilter(false)}
                  selectedUser={(item) => setUserItem(item)}
                  selectedStatus={(item) => setStatus(item)}
                />
              )}
              {handleFilter() === "banks" && (
                <BankFilter
                  state={props.state}
                  method={props.onClick}
                  close={() => showFilter(false)}
                  selectedStatus={(item) => setStatus(item)}
                />
              )}
              {handleFilter() === "product" && (
                <ProductFilter
                  state={props.state}
                  method={props.onClick}
                  close={() => showFilter(false)}
                  selectedUser={(item) => setUserItem(item)}
                  selectedStatus={(item) => setStatus(item)}
                />
              )}
              {handleFilter() === "themes" && (
                <ThemeFilter
                  state={props.state}
                  method={props.onClick}
                  close={() => showFilter(false)}
                  selectedStatus={(item) => setStatus(item)}
                />
              )}
              {handleFilter() === "users" && (
                <UserFilter
                  state={props.state}
                  method={props.onClick}
                  close={() => showFilter(false)}
                  selectedUser={(item) => setUserItem(item)}
                  selectedStatus={(item) => setStatus(item)}
                />
              )}
              {handleFilter() === "zipcodes" && (
                <ZipFilter
                  state={props.state}
                  method={props.onClick}
                  close={() => showFilter(false)}
                  selectedUser={(item) => setUserItem(item)}
                  selectedStatus={(item) => setStatus(item)}
                />
              )}
              {handleFilter() === "videos" && (
                <VideosFilter
                  state={props.state}
                  method={props.onClick}
                  close={() => showFilter(false)}
                  selectedUser={(item) => setUserItem(item)}
                  selectedStatus={(item) => setStatus(item)}
                />
              )}
              {handleFilter() === "services" && (
                <ServicesFilter
                  state={props.state}
                  method={props.onClick}
                  close={() => showFilter(false)}
                  selectedUser={(item) => setUserItem(item)}
                  selectedStatus={(item) => setStatus(item)}
                />
              )}
              {handleFilter() === "questions" && (
                <QuestionsFilter
                  state={props.state}
                  method={props.onClick}
                  close={() => showFilter(false)}
                  selectedUser={(item) => setUserItem(item)}
                  selectedStatus={(item) => setStatus(item)}
                />
              )}
              {handleFilter() === "settings" && (
                <SettingsFilter
                  state={props.state}
                  method={props.onClick}
                  close={() => showFilter(false)}
                  selectedUser={(item) => setUserItem(item)}
                  selectedStatus={(item) => setStatus(item)}
                />
              )}
            </ul>
          </div>
        </div>
      )}
      <FilterStyle />
    </div>
  );
}

export default withRouter(Filter);
